const listeners = new Set<() => void>();

/** All mounted status views re-read permission after an in-app registration attempt. */
export const notifyNativePushChanged = () => listeners.forEach((listener) => listener());

export const subscribeNativePushChanged = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
